import { format, parseISO } from "date-fns";
import { fullDateFullYearFormat } from "@common/helpers/date";

export function formatLockDateMessage(dateString: string | null): string {
    if (!dateString) {
        return "Entity is unlocked";
    }
    return `Entity is locked up to ${format(parseISO(dateString), fullDateFullYearFormat)}`;
}
